import styled from 'styled-components';
import { breakpoint, font } from 'styles/globals';
import { ProfileSummaryContainer } from 'components/MyAccount/ProfileSummary/ProfileSummaryStyles';
import Heading from 'styles/typography/Heading';
import { Theme, getColor } from 'styles/theme';

export const Container = styled.div`
  font-family: ${font.graphikCond};
  display: flex;
  flex-direction: column;
  font-size: 16px;
  line-height: 120%;
  position: sticky;
  top: 80px;
  width: inherit;
`;

export const Title = styled(Heading)<{ theme: Theme }>`
  padding-bottom: 16px;
  border-bottom: 1px solid ${getColor('borderPrimary')};

  @media (${breakpoint.mdMin}) {
    margin-bottom: 40px;
    padding-bottom: 0;
    border-bottom: none;
  }
`;

export const MenuItemWrapper = styled.li<{ $selected: boolean; theme: Theme }>`
  font-weight: 600;
  letter-spacing: 0.5px;
  padding: 16px;
  margin-top: 8px;
  box-shadow: 4px 4px 20px 0px ${getColor('surfaceBlack')}0D;

  @media (${breakpoint.mdMax}) {
    &:first-child {
      padding: 16px 16px 0;
    }
  }

  .accountNavigationItem {
    text-decoration: none;
    &:focus {
      border: none;
    }
  }
  
  .profile {
    border-bottom: 1px solid ${getColor('borderPrimary')};
    padding-bottom: 16px;
  }
  & a {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (${breakpoint.mdMin}) {
      color: ${(props) => (props.$selected ? getColor('textLink') : getColor('textPrimary'))};
    }
  }
  @media (${breakpoint.mdMin}) {
    background-color: ${(props) => (props.$selected ? getColor('brandPrimary') : 'none')};
    .profile {
      border-bottom: none;
      padding-bottom: 0;
    }
  }
  
  &:hover {
    background-color: ${getColor('brandPrimary')};
    a {
      color: getColor('textLink');
    }
  }

  @media (${breakpoint.mdMin}) {
    padding: 8px;
    margin-top: 0;
    box-shadow: none;
    svg {
      display: none;
    }
  }
  
  & ${ProfileSummaryContainer} {
    margin-top: 0;
    padding: 16px 0 0;
    box-shadow: none;
  }
`;

export const MenuItemsWrapper = styled.ul`
`;

export const CustomerSupportWrapper = styled.div`
  margin-top: 90px;
  & p{
    font-style: normal;
    font-weight: 600;
    letter-spacing: 0.5px;
    margin-bottom: 16px;
  }
  & span{
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.5px;
  }
`;

export const MenuItemsCustomerSupport = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  @media (${breakpoint.mdMin}) {
    padding-right: 24px;
    border-right: 1px solid ${getColor('borderPrimary')};
  }
`;
